/* Spring Step Shoes native swatches — isolated from legacy product-card swatch handlers. */
(() => {
  if (window.sssNativeSwatchFallbackInstalled) return;
  window.sssNativeSwatchFallbackInstalled = true;
  const APP_SWATCH = '.swatch-view-item, .swatch-button, .swatch-view, [data-swatch-king], [class*="swatch-king"]';
  const GROUP = '[data-sss-native-card-swatches]';
  let pending = false;
  let observer;

  function visible(node) {
    if (!node || node.closest('[hidden]') || !node.getClientRects().length) return false;
    const styles = getComputedStyle(node);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && Number(styles.opacity) !== 0;
  }
  function appIsVisible(root) {
    try { return !!root && Array.from(root.querySelectorAll(APP_SWATCH)).some(visible); }
    catch (err) { return false; }
  }
  function cardFor(group) { return group.closest('.js-color-swatches-wrapper, .card-wrapper, .card-horizontal-wrapper'); }
  function updateLinks(wrapper, href) {
    if (!href) return;
    wrapper.dataset.sssSelectedVariantLink = href;
    wrapper.querySelectorAll('a[href*="/products/"], a.card-wrapper__link--overlay, a.js-color-swatches-link').forEach((link) => {
      link.setAttribute('href', href);
    });
    wrapper.querySelectorAll('[data-product-url]').forEach((node) => node.setAttribute('data-product-url', href));
  }

  // Product media may exist even when variants have no assigned image.
  // Recover images from the product media families instead of drawing flat dots.
  const productMediaRequests = new Map();
  const mediaHref = m => m?.preview_image?.src || m?.src || m?.image?.src || '';
  function mediaFilename(url) {
    try { return decodeURIComponent(new URL(url, location.origin).pathname.split('/').pop() || ''); }
    catch (err) { return String(url || '').split('?')[0].split('/').pop() || ''; }
  }
  function mediaView(url) { return mediaFilename(url).match(/-(0[1-9])(?:_|[.])/i)?.[1] || ''; }
  const cleanColor = s => String(s || '').trim().toLowerCase().replace(/\s+/g, ' ');
  function resolveColorPhoto(product, color, index, colorValues) {
    const variants = (product.variants || []).filter(v => cleanColor(v.options?.[index]) === cleanColor(color));
    const attached = variants.find(v => v.available !== false && mediaHref(v.featured_media))
      || variants.find(v => mediaHref(v.featured_media));
    if (attached) return mediaHref(attached.featured_media);
    const media = (product.media || []).filter(m => m.media_type === 'image' && mediaHref(m));
    if (!media.length) return '';
    const families = new Map();
    media.forEach(m => {
      const family = mediaFilename(mediaHref(m)).replace(/\.[^.]+$/, '').split('_')[0].replace(/-(0[1-9])$/i, '');
      if (!families.has(family)) families.set(family, []);
      families.get(family).push(m);
    });
    const groups = [...families.values()].filter(images => images.some(m => mediaView(mediaHref(m)) === '05'));
    const allVariantsMissingMedia = !(product.variants || []).some(v => mediaHref(v.featured_media));
    if (allVariantsMissingMedia && groups.length === colorValues.length) {
      const position = colorValues.findIndex(value => cleanColor(value) === cleanColor(color));
      if (position >= 0) {
        const images = groups[position];
        return mediaHref(images.find(m => mediaView(mediaHref(m)) === '05') || images[0]);
      }
    }
    // When some colors have assigned variant images, other colors can be found
    // using their descriptive alt text (e.g. "Belgard boots in Brown").
    const phrase = ' in ' + cleanColor(color);
    const matches = media.filter(m => {
      const alt = cleanColor(m.alt);
      const pos = alt.indexOf(phrase);
      return pos >= 0 && (!alt[pos + phrase.length] || /[^a-z]/.test(alt[pos + phrase.length]));
    });
    return mediaHref(matches.find(m => mediaView(mediaHref(m)) === '05') || matches[0]);
  }
  function sizedMedia(url, width) {
    if (!url) return '';
    try {
      const parsed = new URL(url, location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (err) { return url; }
  }
  function requestProductMedia(handle) {
    if (!productMediaRequests.has(handle)) {
      const url = (window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js';
      productMediaRequests.set(handle, fetch(url, { credentials: 'same-origin' })
        .then(response => response.ok ? response.json() : null)
        .catch(() => null));
    }
    return productMediaRequests.get(handle);
  }
  const resolvingGroups = new WeakSet();
  const mediaIntersection = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          mediaIntersection.unobserve(entry.target);
          hydrateMissingMedia(entry.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;
  async function hydrateMissingMedia(group) {
    if (resolvingGroups.has(group)) return;
    const missing = [...group.querySelectorAll('input[type="radio"]')].filter(input => !input.dataset.variantImage);
    if (!missing.length) return;
    const wrapper = cardFor(group);
    const handle = wrapper?.dataset?.product;
    if (!handle) return;
    resolvingGroups.add(group);
    const product = await requestProductMedia(handle);
    if (!product || !group.isConnected) return;
    const opts = product.options || [];
    const index = opts.findIndex(opt => /colou?r/i.test(typeof opt === 'string' ? opt : opt.name || ''));
    if (index < 0) return;
    const colors = [...group.querySelectorAll('input[type="radio"]')].map(input => input.value);
    missing.forEach(input => {
      const photo = resolveColorPhoto(product, input.value, index, colors);
      if (!photo) return;
      input.dataset.variantImage = sizedMedia(photo, 720);
      const preview = input.closest('.sss-native-card-swatch')?.querySelector('.sss-native-card-swatch__preview');
      if (preview) {
        preview.style.backgroundImage = 'url("' + sizedMedia(photo, 120).replace(/"/g, '%22') + '")';
        preview.style.backgroundColor = '#f4f4f3';
      }
    });
    const checked = group.querySelector('input[type="radio"]:checked');
    if (checked) selectSwatch(checked, false);
  }
  function selectSwatch(input, persist) {
    if (!input || !input.closest(GROUP)) return;
    const group = input.closest(GROUP);
    if (group.hidden) return;
    const wrapper = cardFor(group);
    if (!wrapper) return;
    const url = input.dataset.productLink || input.dataset.variantLink;
    group.querySelectorAll('input[type="radio"]').forEach((node) => { node.checked = node === input; });
    updateLinks(wrapper, url);
    const isOtherProduct = !!input.dataset.productLink &&
      !!url && !url.includes('/products/' + encodeURIComponent(wrapper.dataset.product));
    const hiddenVariant = wrapper.querySelector('.card__add-to-cart input[name="id"]');
    if (hiddenVariant && input.dataset.variantId && !isOtherProduct) hiddenVariant.value = input.dataset.variantId;
    const preview = wrapper.querySelector('img.media--first, .media--first img');
    if (preview && input.dataset.variantImage) {
      preview.removeAttribute('srcset');
      preview.src = input.dataset.variantImage;
      preview.setAttribute('data-sss-native-color', input.value);
      // Hide only the static default-color hover photo. Never delete slider
      // images: editorial and collection card carousels need those DOM nodes.
      wrapper.querySelectorAll('.card__inner .media--hover-effect > img.media--second')
        .forEach((node) => { node.hidden = true; });
      try { wrapper.querySelector('.swiper.product-card-js')?.swiper?.slideTo(0, 0, false); }
      catch (error) {}
    }
    // Keep quick add tied to the selected variant, never the old default color.
    const quickView = wrapper.querySelector('.quick-add-view');
    if (quickView && url) quickView.setAttribute('data-product-url', url);
    if (persist && wrapper.dataset.product) {
      try { sessionStorage.setItem('sss-card-variant:' + wrapper.dataset.product,
        JSON.stringify({ variantId: input.dataset.variantId || '',
                         variantLink: url || '', color: input.value })); }
      catch (err) {}
    }
  }
  function restore(wrapper, group) {
    if (wrapper.dataset.sssNativeRestored === '1') return;
    wrapper.dataset.sssNativeRestored = '1';
    let state = null;
    try { state = JSON.parse(sessionStorage.getItem('sss-card-variant:' + wrapper.dataset.product) || 'null'); }
    catch (err) {}
    const inputs = Array.from(group.querySelectorAll('input[type="radio"]'));
    const wanted = (state && inputs.find(x => (state.variantId && x.dataset.variantId === state.variantId) ||
      (state.color && x.value === state.color))) ||
      inputs.find(x => x.checked) || inputs[0];
    if (wanted) selectSwatch(wanted, false);
  }
  function sync() {
    pending = false;
    document.querySelectorAll(GROUP).forEach((group) => {
      bindGroup(group);
      const wrapper = cardFor(group);
      if (!wrapper) return;
      const scope = wrapper.closest('.collection-product-card, .product-card-item, .editorial-products-showcase__product, .eci-product-card') || wrapper;
      // The native controls use product-linked 05 photos; card-level Swatch King
      // can supply a mixed set of legacy swatches and thumbnail crops.
      // Keep the app untouched on PDP while using one consistent card picker.
      const hideNative = false;
      group.hidden = hideNative;
      group.setAttribute('aria-hidden', hideNative ? 'true' : 'false');
      if (!hideNative) {
        restore(wrapper, group);
        if ([...group.querySelectorAll('input[type="radio"]')].some(input => !input.dataset.variantImage)) {
          if (mediaIntersection) mediaIntersection.observe(group);
          else hydrateMissingMedia(group);
        }
      }
    });
    document.querySelectorAll('fieldset.product-form__controls--colors').forEach((fieldset) => {
      const info = fieldset.closest('.product__info-container, .product__info-wrapper, .product__info') ||
        fieldset.closest('.product-parameters') || fieldset.parentElement?.parentElement || fieldset;
      fieldset.classList.toggle('sss-swatchking-active', appIsVisible(info));
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.setTimeout(sync, 120);
  }
  // Keep the radio click on the card; don't allow any enclosing grid/link handler to navigate.
  function bindGroup(group) {
    if (group.dataset.sssNativeEventsReady === '1') return;
    group.dataset.sssNativeEventsReady = '1';
    group.addEventListener('click', (event) => {
      const label = event.target.closest('.sss-native-card-swatch');
      if (!label) return;
      event.stopPropagation();
      // Clicking an already selected color should still keep the card synced.
      const input = label.querySelector('input[type="radio"]');
      if (input) queueMicrotask(() => selectSwatch(input, true));
    }, false);
    group.addEventListener('change', (event) => {
      const input = event.target.closest('input[type="radio"]');
      if (!input) return;
      event.stopPropagation();
      selectSwatch(input, true);
    }, false);
  }
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('sss:variant-picker-updated', schedule);
  function initialize() {
    schedule();
    if (observer || !document.body) return;
    observer = new MutationObserver((records) => {
      if (records.some(m => m.addedNodes.length || m.removedNodes.length)) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  window.addEventListener('load', schedule);
})();
